module.exports = __webpack_public_path__ + "img/pit-min.bbdb05a2.png";